<div class="detail-form">
  <div class="row mt-md-2">
    <div class="col-md-12">
      <cap-kopfdatenelement bodyClass="col-md-10" label="Eintragung" labelClass="col-md-2">
        @switch (rolle.rolle) {
          @case (RolleEnum.EIGENTUEMER) {
            <span [capHistinfo]="version.histInfo">{{ rolle.eigentumsform | translate }} {{ "an" | translate }}</span>
            <cap-kompakt-grundstueck [capHistinfo]="rolle.eigentum.histInfo" [item]="rolle.eigentum"></cap-kompakt-grundstueck>
          }
          @case (RolleEnum.UEBRIGE_BERECHTIGTE) {
            <span [capHistinfo]="version.histInfo">{{ "BerechtigtAn" | translate }}</span>
            <cap-kompakt-standardrecht [histInfo]="rolle.beziehungZuRecht.version.histInfo" [recht]="rolle.beziehungZuRecht">
            </cap-kompakt-standardrecht>
          }
          @case (RolleEnum.GLAEUBIGER) {
            <span [capHistinfo]="version.histInfo">{{ "GlaeubigerGlaeubigerinVon" | translate }}</span>
            <ng-template [ngTemplateOutlet]="kompaktgrundpfandrecht"></ng-template>
          }
          @case (RolleEnum.SCHULDNER) {
            <span [capHistinfo]="version.histInfo">{{ "SchuldnerSchuldnerinVon" | translate }}</span>
            <ng-template [ngTemplateOutlet]="kompaktgrundpfandrecht"></ng-template>
          }
        }
      </cap-kopfdatenelement>
    </div>
  </div>
</div>

<ng-template #kompaktgrundpfandrecht>
  <cap-kompakt-grundpfandrecht
    [histInfo]="rolle.beziehungZuRecht.version.histInfo"
    [masterId]="rolle.beziehungZuRecht.id"
    [rechteId]="rolle.beziehungZuRecht.rechteId"
    [version]="rolle.beziehungZuRecht.version">
  </cap-kompakt-grundpfandrecht>
</ng-template>
